import React from 'react';

// ヒーロー用 AYUBITO スライド（白基調の和モダン：紺＋赤＋金）
const AyubitoHeroSlide = ({ slideData }) => {
  const img = process.env.PUBLIC_URL + (slideData.image || '/hero05-1.png');
  const bg = process.env.PUBLIC_URL + (slideData.bgImage || '/hero-bg.png');

  const styles = {
    wrap: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: '#ffffff',
      backgroundImage: `url(${bg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center bottom',
      backgroundRepeat: 'no-repeat',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0 24px',
      overflow: 'hidden',
    },
    inner: {
      maxWidth: '1080px',
      width: '100%',
      display: 'grid',
      gridTemplateColumns: '1.05fr 0.95fr',
      gap: '40px',
      alignItems: 'center',
    },
    copy: { textAlign: 'left' },
    badge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      background: '#fdecea',
      color: '#d8382b',
      fontWeight: 'bold',
      fontSize: '13px',
      borderRadius: '999px',
      padding: '8px 16px',
      marginBottom: '18px',
    },
    badgeRel: { color: '#3a4d78' },
    head: {
      fontSize: 'clamp(18px, 2.8vw, 30px)',
      fontWeight: 'bold',
      color: '#14274e',
      lineHeight: 1.4,
      margin: 0,
    },
    red: { color: '#d8382b' },
    word: {
      fontSize: 'clamp(32px, 5.5vw, 52px)',
      fontWeight: 'bold',
      letterSpacing: '0.1em',
      color: '#14274e',
      margin: '6px 0 20px',
    },
    cta: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '10px',
      background: '#14274e',
      color: '#ffffff',
      fontWeight: 'bold',
      fontSize: '15px',
      padding: '14px 30px',
      borderRadius: '999px',
      textDecoration: 'none',
      transition: 'background-color 0.3s',
    },
    imgWrap: { display: 'flex', justifyContent: 'center' },
    img: { width: '100%', maxWidth: '420px', height: 'auto', display: 'block' },
  };

  return (
    <div style={styles.wrap}>
      <style>
        {`
          @media (max-width: 768px) {
            .ayb-hero-inner {
              grid-template-columns: 1fr !important;
              gap: 10px !important;
              text-align: center !important;
            }
            .ayb-hero-copy { text-align: center !important; order: 2; }
            .ayb-hero-imgwrap { order: 1; }
            .ayb-hero-img { max-width: 150px !important; }
            .ayb-hero-word { font-size: 30px !important; margin: 4px 0 14px !important; }
            .ayb-hero-badge { font-size: 11px !important; margin-bottom: 12px !important; }
          }
        `}
      </style>
      <div style={styles.inner} className="ayb-hero-inner">
        <div style={styles.copy} className="ayb-hero-copy">
          <div style={styles.badge} className="ayb-hero-badge">
            訪日インバウンド 多言語GPS音声ガイド
            <span style={styles.badgeRel}>※2026年秋リリース予定</span>
          </div>
          <div style={styles.head}>
            街の<span style={styles.red}>歩み</span>と、人の<span style={styles.red}>歩み</span>を<br />
            AI多言語音声ガイドでつなぐ
          </div>
          <div style={styles.word} className="ayb-hero-word">AYUBITO</div>
          <a
            href={slideData.ctaUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.cta}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#0e1b39'; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#14274e'; }}
          >
            {slideData.ctaText || '公式サイトを見る'} →
          </a>
        </div>
        <div style={styles.imgWrap} className="ayb-hero-imgwrap">
          <img
            src={img}
            alt="AYUBITO 多言語GPS音声ガイド"
            style={styles.img}
            className="ayb-hero-img"
          />
        </div>
      </div>
    </div>
  );
};

export default AyubitoHeroSlide;
